$(function () {

  if (window.matchMedia('(max-width: 767px)').matches) return;

  $('.js-scroll').each(function () {
    const $root = $(this);      // ← 追加
    const $scroller = $root;   // ← 実体はこれ

    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;
    let moved = false;

    // aタグのドラッグ挙動を殺す
    $root.find('a').css({
      'user-drag': 'none',
      '-webkit-user-drag': 'none',
      'user-select': 'none'
    });

    // ドラッグ後のクリック誤発火防止
    $root.on('click', 'a', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    });

    // mousedown
    $root.on('mousedown', function (e) {
      if (e.button !== 0) return;

      isDown = true;
      moved = false;

      startX = e.clientX;
      scrollLeft = $scroller.scrollLeft();

      document.body.style.userSelect = 'none';
      $root.addClass('is-dragging');

      e.preventDefault();
    });

    // mousemove
    $(window).on('mousemove.dragScroll', function (e) {
      if (!isDown) return;

      const dx = startX - e.clientX;
      if (Math.abs(dx) > 5) moved = true;

      $scroller.scrollLeft(scrollLeft + dx);
      e.preventDefault();
    });

    // mouseup / blur
    $(window).on('mouseup.dragScroll blur.dragScroll', function () {
      if (!isDown) return;

      isDown = false;
      document.body.style.userSelect = '';
      $root.removeClass('is-dragging');
    });
  });

});

$(function(){
	$('.js-ac .js-accnt').hide();
	//$('.js-ac:first-of-type .js-acbtn').addClass('ac');
	$('.js-acbtn').click(function(){
		var headerHeight = $('header').outerHeight();
		var target = $(this).parents(".js-ac");
		var position = (target.offset().top - headerHeight);	
		
		$(this).next(".js-accnt").slideToggle();
		//$(this).parent().toggleClass("open");
		if (window.matchMedia( "(max-width: 767px)" ).matches) {
			if($(this).hasClass('ac')){
				$('body,html').animate({scrollTop:position});
			}
		}
		$(this).toggleClass("ac");
		return false;
		
		});
});

$(document).ready(function() {
    var popup = $(".fixed-bnr");
    var closeBtn = $(".fixed-bnr .close");

    popup.show();

    closeBtn.click(function() {
        popup.hide();
    });
});
